<div ngModelGroup="address">

  @if (stepName !== 'payment') {
    <!--Prefix-->
    <div class="w-12">
      <input-wrap>
      <select class="input"
        name="prefix"
        autocomplete="honorific-prefix"
        [(ngModel)]="data.prefix"
        [muiInput]="'Title'| translate"
        required>
        @for (prefix of prefixes; track prefix) {
          <option
            [value]="prefix">
            {{prefix}}
          </option>
        }
      </select>
    </input-wrap>
  </div>
  <!--First name && Last name-->
  <input-wrap class="w-12 m-t-5"
    [messages]="{required: 'Please enter first name'}">
  <input class="input"
    type="text"
    name="firstname"
    cy-addressAddFname
    (blur)="onInputBlur()"
    autocomplete="given-name"
    [muiInput]="('First name'| translate)"
    maxlength="100"
    [(ngModel)]="data.firstname"
    required>
</input-wrap>
<input-wrap class="w-12 m-t-5"
  [messages]="{required: 'Please enter last name'}">
<input class="input"
  type="text"
  name="lastname"
  (blur)="onInputBlur()"
  cy-addressAddLname
  autocomplete="family-name"
  [muiInput]="('Last name'| translate)"
  maxlength="50"
  [(ngModel)]="data.lastname"
  required>
</input-wrap>
<!--Phone-->
<input-wrap class="w-12 m-t-5"
  [messages]="{required: 'Please enter telephone'}">
<input class="input"
  type="text"
  name="telephone"
  #phoneInput
  validatePattern="telephone"
  inputmode="numeric"
  (blur)="onInputBlur()"
  autocomplete="tel"
  cy-addressAddPhone
  [muiInput]="('Phone'| translate)"
  maxlength="30"
  [(ngModel)]="telephoneNumber"
  required>
</input-wrap>
<p class="col-11 c1 m-t-1">{{'Please provide a mobile number for delivery tracking' | translate}}
</p>
}

<!--Country-->
<input-wrap class="w-12 m-t-5"
  [messages]="{required: 'Please select country'}">
<select class="input"
  name="country"
  autocomplete="country"
  cy-addressAddCountry
  [muiInput]="('Country'| translate)"
  [(ngModel)]="data.country_id"
  (change)="onCountryChange()"
  required>
  @for (country of countries | orderBy: ['name']; track country) {
    <option
    [value]="country.code">{{country.name| translate}}</option>
  }
</select>
</input-wrap>

@if (searcher) {
  <div class="pos-relative m-t-5"
    (offClick)="searcher.clear()"
    [offClickOff]="!searcher.hints?.length">
    <input-wrap [ngClass]="{'is-busy': searcher.status.busy}">
    <input class="input"
      type="text"
      name="query"
      autocomplete="no-autocomplete"
      [muiInput]="('Search for an address or postcode' | translate)"
      [(ngModel)]="searcher.query"
      (keydown.enter)="search()"
      (focus)="search()"
      (blur)="search()">
    @if (searcher.status.busy) {
      <span class="pos-absolute top-0 right-2 bottom-0 flex flex-middle flex-justify-center pe-none"
        >
        <i class="icon-loading"></i>
      </span>
    }
    <!-- open -->
    <div class="hide-up-container pos-absolute left-0 right-0">
      <div class="ng-hide-animate hide-up bg-col-w z-3 b-a b-t-0 overflow-y-scroll"
        [class.ng-hide]="!searcher.hints?.length"
        style="max-height: 20em;"
        role="listbox"
        [attr.aria-hidden]="!searcher.hints?.length"
        [attr.tabindex]="searcher.hints?.length ? 0 : -1">
        <ul>
          @for (hint of searcher.hints; track searcher.trackByHint($index, hint)) {
            <li role="option"
              (click)="searcher.search(hint)"
              >
              <button type="button"
                class="p-a-2 w-12 left">
                <p class="p2">{{hint['Text']}} {{hint['Description']}}</p>
              </button>
            </li>
          }
        </ul>
      </div>
    </div>
  </input-wrap>
</div>
}

<input-wrap class="p-l-1 block left m-t-5">
<checkbox [(ngModel)]="displayFormLocal"
  name="address">
  <span class="p2"
  translate>Enter address manually</span>
</checkbox>
</input-wrap>

<div [ngClass]="{'ng-hide' : !displayFormLocal}">

  @if (stepName === 'payment') {
    <!--Prefix-->
    <div class="w-12 m-t-5">
      <input-wrap>
      <select class="input"
        name="prefix"
        autocomplete="honorific-prefix"
        [(ngModel)]="data.prefix"
        [muiInput]="'Title'| translate"
        required>
        @for (prefix of prefixes; track prefix) {
          <option
            [value]="prefix">
            {{prefix}}
          </option>
        }
      </select>
    </input-wrap>
  </div>
  <!--First name && Last name-->
  <input-wrap class="w-12 m-t-5"
    [messages]="{required: 'Please enter first name'}">
  <input class="input"
    type="text"
    name="firstname"
    cy-addressAddFname
    (blur)="onInputBlur()"
    autocomplete="given-name"
    [muiInput]="('First name'| translate)"
    maxlength="100"
    [(ngModel)]="data.firstname"
    required>
</input-wrap>
<input-wrap class="w-12 m-t-5"
  [messages]="{required: 'Please enter last name'}">
<input class="input"
  type="text"
  name="lastname"
  (blur)="onInputBlur()"
  cy-addressAddLname
  autocomplete="family-name"
  [muiInput]="('Last name'| translate)"
  maxlength="50"
  [(ngModel)]="data.lastname"
  required>
</input-wrap>
<!--Phone-->
<input-wrap class="w-12 m-t-5"
  [messages]="{required: 'Please enter telephone'}">
<input class="input"
  type="text"
  name="telephone"
  #phoneInput
  validatePattern="telephone"
  inputmode="numeric"
  (blur)="onInputBlur()"
  autocomplete="tel"
  cy-addressAddPhone
  [muiInput]="('Phone'| translate)"
  maxlength="30"
  [(ngModel)]="telephoneNumber"
  required>
</input-wrap>
<p class="col-11 c1 m-t-1">{{'Please provide a mobile number for delivery tracking' | translate}}
</p>
}

<!--Street Name-->
<input-wrap class="w-12 m-t-7"
  [messages]="{required: 'Please enter street'}">
<input class="input"
  type="text"
  name="street_1"
  (blur)="onInputBlur()"
  cy-addressAddFirstLine
  [muiInput]="('Address line 1'| translate)"
  maxlength="100"
  autocomplete="address-line1"
  [(ngModel)]="data.street_1"
  required>
</input-wrap>

<input-wrap class="w-12 m-t-5"
  [messages]="{maxlength: 'Address field too long, please try again'}">
<input class="input"
  type="text"
  name="street_2"
  (blur)="onInputBlur()"
  autocomplete="address-line2"
  cy-addressAddSecondLine
  [muiInput]="('Address line 2'| translate)"
  maxlength="100"
  [(ngModel)]="data.street_2">
</input-wrap>

<!--Town-->
<input-wrap class="w-12 m-t-5"
  [messages]="{required: 'Please enter town'}">
<input class="input"
  type="text"
  name="city"
  (blur)="onInputBlur()"
  cy-addressAddCity
  [muiInput]="('Town'| translate)"
  maxlength="30"
  autocomplete="address-level2"
  [(ngModel)]="data.city"
  required>
</input-wrap>

<!--Region-->
@if (!regions) {
  <input-wrap class="w-12 m-t-5"
    [messages]="{required: 'Please enter region'}">
  <input class="input"
    type="text"
    (blur)="onInputBlur()"
    name="region"
    cy-addressAddRegion
    [muiInput]="('County'| translate)"
    maxlength="30"
    autocomplete="address-level1"
    [(ngModel)]="data.region"
    [required]="regionRequired">
</input-wrap>
}
@if (regions) {
  <input-wrap class="w-12 m-t-5"
    [messages]="{required: 'Please enter region'}">
  <select class="select"
    name="region_id"
    cy-addressAddRegionId
    [muiInput]="('County'| translate)"
    autocomplete="address-level1"
    [(ngModel)]="data.region_id"
    [required]="regionRequired">
    <option value=""></option>
    @for (region of regions | orderBy: ['name']; track trackByCode($index, region)) {
      <option
      [value]="region.id">{{region.name}}</option>
    }
  </select>
</input-wrap>
}

<!--Post Code-->
<input-wrap class="w-12 m-t-5"
  [messages]="{required: 'Please enter postcode'}">
<input class="input"
  type="text"
  name="postcode"
  cy-addressAddPostcode
  autocomplete="postal-code"
  [muiInput]="('Post Code'| translate)"
  maxlength="20"
  [(ngModel)]="data.postcode"
  required>
</input-wrap>
</div>
</div>
